<template>
  <el-card>
    <template #header>
      <content-header/>
    </template>
    <el-row type="flex" justify="center">
      <lz-form ref="form" :get-data="getData" :submit="onSubmit" :form.sync="form" :errors.sync="errors" :edit-mode="editMode">
        <el-form-item label="名称" required prop="name">
          <el-input v-model="form.name"/>
        </el-form-item>

        <el-form-item label="终端号" required prop="terminal_number">
          <el-input v-model="form.terminal_number"/>
        </el-form-item>

        <el-form-item label="终端密钥" required prop="terminal_msign">
          <el-input v-model="form.terminal_msign"/>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-switch v-model="form.status" active-text="启用" inactive-text="禁用" />
        </el-form-item>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import LzForm from '@c/LzForm'
import {
  editPrinterDevice,
  updatePrinterDevice,
  storePrinterDevice,
  createPrinterDevice,
} from '@/api/printer-devices'
import FormHelper from '@c/LzForm/FormHelper'

export default {
  name: 'Form',
  components: {
    LzForm,
  },
  mixins: [
    FormHelper,
  ],
  data() {
    return {
      form: {
        name: '',
        terminal_number: '',
        terminal_msign: '',
        status: true,
      },
      errors: {},
    }
  },
  methods: {
    async getData() {
      let data
      if (this.editMode) {
        ({ data } = await editPrinterDevice(this.resourceId))
        this.fillForm(data)
      } else {
        ({ data } = await createPrinterDevice())
      }
    },
    async onSubmit() {
      if (this.editMode) {
        await updatePrinterDevice(this.resourceId, this.form)
      } else {
        await storePrinterDevice(this.form)
      }
    },
  },
}
</script>

<style scoped lang="scss">
</style>
